require("./sitio");
require("@fancyapps/fancybox");

require("slick-carousel");

if ($("#club-house").length) {
    $(".galeria").slick({
        dots: false,
        arrows: false,

        infinite: true,
        speed: 300,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 1,

        prevArrow:
            '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/marina-alicura/boton_izquierda.svg"/></a>',

        nextArrow:
            '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/marina-alicura/boton_derecha.svg"/></a>',

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
}

if ($("#servicios-slide").length) {
    $(".galeria-servicios")
        .slick({
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,

            prevArrow:
                '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/marina-alicura/boton_izquierda.svg"/></a>',

            nextArrow:
                '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/marina-alicura/boton_derecha.svg"/></a>',
        })
        .on("afterChange", function (event, slick, direction, x) {
            var id = $(".galeria-servicios")
                .find(".slick-current")
                .find(".item")
                .data("id");
            $(".titulos").find(".item-texto").removeClass("item-active");

            $(id).addClass("item-active");
        });
}

$(document).ready(function () {
    $("#collapse-membresia").on("click", function () {
        if ($("#listado-membresia").is(":visible")) {
            $("#listado-membresia").hide();
        } else {
            $("#listado-membresia").show();
        }
    });

    $("#collapse-pagos").on("click", function () {
        if ($("#listado-pagos").is(":visible")) {
            $("#listado-pagos").hide();
        } else {
            $("#listado-pagos").show();
        }
    });



});

require("./modal_promocion");


require("./components/FormularioMarinaAlicura");
